import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Typography } from '../../../components/Typography';
import DownloadButton from '../../../components/DownloadButton';
import {
  downloadReport,
  clearDownloadReport,
} from '../../actions/downloadReport';
import useCreateBlob from './useCreateBlob.hook';

import './index.scss';

export const DocumentTypes = {
  LAB_REPORT: 'labReport',
  REIMBURSEMENT_RECEIPT: 'reimbursementReceipt',
};

const TestResultsDocuments = ({ documents, dispatch, data, error }) => {
  const {
    labReport,
    reimbursementReceipt,
    immunotherapyMedicationPrescription,
    sympthomsMedicationPrescription,
  } = documents;

  // There is a case where in Test Results page, we can have 2 download buttons for reports, one in content and one in recommended actions. It was triggering double download, this ref is to avoid that.
  // only download for the button clicked
  const wasClickedRef = useRef(false);

  const { downloadDocument, downloadError } = useCreateBlob(
    data,
    labReport,
    () => {
      wasClickedRef.current = false;
      dispatch(clearDownloadReport());
    },
  );

  useEffect(() => {
    if (data && wasClickedRef.current) {
      downloadDocument();
    }
  }, [data, downloadDocument]);

  const downloadLabReport = (type, report) => {
    wasClickedRef.current = true;
    dispatch(downloadReport(type, report));
  };

  const isAnyDocumentAvailable =
    labReport ||
    reimbursementReceipt ||
    immunotherapyMedicationPrescription ||
    sympthomsMedicationPrescription;

  return (
    <div className='documents'>
      {isAnyDocumentAvailable && (
        <Typography element='p' variant='overline' className='documents__title'>
          <FormattedMessage id='app.documents' defaultMessage='Documents' />
        </Typography>
      )}

      <div className='documents__download-buttons-wrapper'>
        {labReport && (
          <DownloadButton
            text={
              <FormattedMessage
                id='app.lab-report'
                defaultMessage='Lab report'
              />
            }
            description={
              <FormattedMessage
                id='app.download-lab-report'
                defaultMessage='Download lab report'
              />
            }
            onClick={() =>
              downloadLabReport(DocumentTypes.LAB_REPORT, labReport)
            }
            error={error}
            downloadError={downloadError}
          />
        )}

        {reimbursementReceipt && (
          <DownloadButton
            className='documents__line'
            text={
              <FormattedMessage
                id='app.reimbursement-receipt'
                defaultMessage='Reimbursement receipt'
              />
            }
            description={
              <FormattedMessage
                id='app.download-reimbursement-receipt'
                defaultMessage='Download reimbursement receipt'
              />
            }
            onClick={() =>
              downloadLabReport(
                DocumentTypes.REIMBURSEMENT_RECEIPT,
                reimbursementReceipt,
              )
            }
            error={error}
          />
        )}

        {immunotherapyMedicationPrescription && (
          <DownloadButton
            className='documents__line'
            text={
              <FormattedMessage
                id='test-result.immunotherapy-medication-prescription'
                defaultMessage='Immunotherapy medication prescription'
              />
            }
            description={
              <FormattedMessage
                id='test-result.download-immunotherapy-medication-prescription'
                defaultMessage='Download immunotherapy medication prescription'
              />
            }
            onClick={() =>
              console.log('download mmunotherapy medication prescription')
            }
          />
        )}

        {sympthomsMedicationPrescription && (
          <DownloadButton
            className='documents__line'
            text={
              <FormattedMessage
                id='test-result.sympthoms-medication-prescription'
                defaultMessage='Sympthoms medication prescription'
              />
            }
            description={
              <FormattedMessage
                id='test-result.download-sympthoms-medication-prescription'
                defaultMessage='Download sympthoms medication prescription'
              />
            }
            onClick={() =>
              console.log('download sympthoms medication prescription')
            }
          />
        )}
      </div>
    </div>
  );
};

TestResultsDocuments.propTypes = {
  documents: PropTypes.object,
  dispatch: PropTypes.func,
  data: PropTypes.object,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  data: state.downloadReport.get('data'),
  loading: state.videoUpload.get('loading'),
  error: state.app.get('error'),
});

export default connect(mapStateToProps)(TestResultsDocuments);
